import { clsx } from 'clsx'

const youtubeRegexp = /\[youtube:(?<code>[\w-]+)\]/giu
const threeQregexp = /\[3q data-id="(?<code>[\w-]+)" layout="responsive"\]/giu

const replaceYoutubeString = (content: string): string => {
  // wsawa-5304: Need to remove youtube videos all together from legal perspective, for fail safe even if there is a link, replace it with empty string
  return content.replaceAll(youtubeRegexp, '')
}

/**
 * We just return HTML string here to avoid using renderToString on client which adds +20kb to bundle size.
 */
const getThreeQplayerHtmlString = (code?: string): string => {
  if (!code) {
    return ''
  }

  const url = `https://playout.3qsdn.com/embed/${code}`

  // eslint-disable-next-line no-inline-comments -- for IDE hightlighting
  return /* HTML */ `<div
    class="${clsx('threeQ', 'mb-3.5 w-full overflow-auto')}"
    data-embed="$1"
  >
    <div class="relative cursor-pointer overflow-hidden pt-[56.25%]">
      <iframe
        allow="picture-in-picture; encrypted-media; fullscreen"
        allowfullscreen=""
        class="absolute left-0 top-0 size-full"
        height="100%"
        loading="lazy"
        src="${url}"
        title="3Q SDN"
        width="100%"
      ></iframe>
    </div>
  </div>`
}

const replaceThreeQstring = (content: string): string => {
  return content.replaceAll(threeQregexp, (_match, code: string) => {
    return getThreeQplayerHtmlString(code)
  })
}

export const useParseVideoStrings = (field: string): string => {
  let parsedField = replaceYoutubeString(field)
  parsedField = replaceThreeQstring(parsedField)

  return parsedField
}
